module.exports = __webpack_public_path__ + "img/文案.e6461440.png";